import React from "react";
import { getImg } from "../../Api/getImg";
import { BiMapPin } from "react-icons/bi";

const PatientHeader = ({ patient, currentStep }) => {
  return (
    <div className="bg-white border-b border-gray-200 md:px-6 py-4">
      <div className="flex items-center md:justify-between">
        <div className="flex items-center gap-4">
          <div className=" w-10 h-10 md:w-16 md:h-16 bg-gradient-to-r from-primary to-primary rounded-full flex items-center justify-center text-white font-bold text-sm md:text-xl">
            {patient?.imageId ? (
              <img
                src={getImg(patient.imageId)}
                className="rounded-full md:w-full md:h-full object-cover"
                alt={patient?.fullName}
              />
            ) : (
              <span>{patient?.fullName?.charAt(0).toUpperCase()}</span>
            )}
          </div>
          <div>
            <h2 className="text-lg md:text-2xl font-bold text-gray-800 flex items-center md:gap-2">
              {patient?.fullName || 'Patient'}'s {currentStep === 2 ? 'Invoice' : 'Report'}
            </h2>
            <p className="text-sm flex items-center gap-2 text-gray-500 mt-1">
              <BiMapPin /> {patient?.clinicName || 'No clinic assigned'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientHeader;